import Page from './Page.js';
import Motion from './Motion.js';
import "babel-polyfill";

/**
 * Class Realisations
 */
class Realisations extends Page{


  /**
   * Constructor
   */
  constructor(currentPageId, slug = ""){
    super();
    // Properties
    this.slug = slug;
    this.filters = [];
    this.realisations = [];
    this.currentPageId = currentPageId;
    this.pagination = 2; // set first page as page 2
    this.perPage = 6;
    this.perPageFirst = 12;
    this.motion = new Motion;
    this.dryLoad = false;

    // Listeners
    this.realisationsScrollListener = this.realisationsScroll.bind(this);
  }


  /**
   * Init
   */
  init(){

  }


  /**
   * Set realisations events listeners
   */
  setEventsListeners() {
    console.log('set realisations events listeners');
    /*
    if(document.getElementById("realisations-realisations-list")){
      var realisationsListAnchors
        = document.getElementById("realisations-realisations-list")
        .getElementsByTagName('a');
      for(var i=0, len=realisationsListAnchors.length; i<len; i++){
        realisationsListAnchors[i].addEventListener(
          'click',
          this.clickOnRealisationsListItem,
          false
        );
        realisationsListAnchors[i].addEventListener(
          'mouseover',
          this.motion.mouseOverRealisationsListItem,
          false
        );
        realisationsListAnchors[i].addEventListener(
          'mouseout',
          this.motion.mouseOutRealisationsListItem,
          false
        );
      }
    }
    if(document.getElementById("realisations-menu")){
      var realisationsFiltersAnchors
        = document.getElementById("realisations-menu")
        .getElementsByTagName('a');
      for(var i=0, len=realisationsFiltersAnchors.length; i<len; i++){
        realisationsFiltersAnchors[i].addEventListener(
          'click',
          this.clickOnRealisationsFiltersItem,
          false
        );
      }
    }*/
    window.addEventListener(
      "scroll",
      this.realisationsScrollListener,
      false
    );
  }


  /**
   * Unset realisations event listeners
   */
  unsetEventsListeners() {
    console.log('unset realisations events listeners');
    if(document.getElementById("realisations-realisations-list")){
      var realisationsListAnchors = document
        .getElementById("realisations-realisations-list")
        .getElementsByTagName('a');
      for(var i=0, len=realisationsListAnchors.length; i<len; i++){
        realisationsListAnchors[i].removeEventListener(
          'click',
          this.clickOnRealisationsListItem,
          false
        );
        realisationsListAnchors[i].removeEventListener(
          'mouseover',
          this.motion.mouseOverRealisationsListItem,
          false
        );
        realisationsListAnchors[i].removeEventListener(
          'mouseout',
          this.motion.mouseOutRealisationsListItem,
          false
        );
      }
    }
    if(document.getElementById("realisations-menu")){
      var realisationsFiltersAnchors
        = document.getElementById("realisations-menu")
        .getElementsByTagName('a');
      for(var i=0, len=realisationsFiltersAnchors.length; i<len; i++){
        realisationsFiltersAnchors[i].removeEventListener(
          'click',
          this.clickOnRealisationsFiltersItem,
          false
        );
      }
    }
    window.removeEventListener(
      "scroll",
      this.realisationsScrollListener,
      false
    );
  }


  /**
   * Click on Realisations List Item
   */
  clickOnRealisationsListItem(e) {
    console.log('click on realisations list item');
    e.preventDefault();
    var parts = this.href.split('/');
    var slug = (parts[parts.length - 1])
      ? (parts[parts.length - 1])
      : (parts[parts.length - 2]);
    // @TODO: Refactor thrown event;
    var e = document.createEvent("CustomEvent");
    e.initCustomEvent('realisations_single_nav_call', false, false, {
      'realisation': this
    });
    window.dispatchEvent(e);
  }




  /**
   * Click on Realisations Filters Item
   */
  clickOnRealisationsFiltersItem(e) {
    console.log('click on realisations filters item');
    e.preventDefault();
    // @TODO: Refactor thrown event;
    var e = document.createEvent("CustomEvent");
    e.initCustomEvent('realisations_filters_nav_call', false, false, {
      'filter': this
		});
    window.dispatchEvent(e);
  }


  /**
   * Load next realisations
   */
  loadNextRealisations() {
    console.log('load next realisations');
    if (this.pagination > 0) {
      console.log('current pagination')
      console.log(this.pagination);
      this.pagination++;
      console.log('new pagination')
      console.log(this.pagination);
      this.ajax("/wp-json/wp/v2/realisations?per_page="
          + this.perPage
          + "&page="
          + this.pagination).then(
          function(result) {
            var data= JSON.parse(result);
            var index = 1;
            this.realisations = [];
            for (var item of data){
              var realisation = [];
              realisation['title'] = item.title.rendered;
              realisation['href']= item.link;
              realisation['id'] = item.id;
              // check if featured media is available
              realisation['thumbnail']
                = (item["_links"]["wp:featuredmedia"])
                ? (item["_links"]["wp:featuredmedia"][0]['href'])
                : "";
              this.realisations.push(realisation);
            }
            console.log("number of fetched realisations");
            console.log(this.realisations.length);
            if (this.realisations.length < 1) {
              this.pagination = 0;
              this.setEventsListeners();
              this.motion.initRealisationsListStyle();
              this.motion.enableScroll();
            }
            else if (this.realisations.length < this.perPage) {
              this.pagination = 0;
              // @TODO: ugly code, refactor
              document.getElementById('realisations-spinner').style.display = "block";
              this.multipleCallbackMedia2(this.realisations.length-1);
            }
            else{
              // @TODO: ugly code, refactor
              document.getElementById('realisations-spinner').style.display = "block";
              this.multipleCallbackMedia2(this.realisations.length-1);
            }
          }.bind(this)
      ).catch(function(msg) {
        console.log(msg);
      });
    } else {
      this.setEventsListeners();
      this.motion.initRealisationsListStyle();
      this.motion.enableScroll();
      this.disablePagination();
    }
  }
  // @TODO: ugly code, refactor
  multipleCallbackMedia2(index){
    if(this.realisations[index]["thumbnail"].length > 0){
      this.ajax(this.realisations[index]["thumbnail"]).then(
        function(result) {
          var thumbnailObject = JSON.parse(result);
          this.realisations[index]['thumbnail']
            = thumbnailObject.media_details.sizes.realisations_list.source_url;
          if (index > 0){
            index--;
            this.multipleCallbackMedia2(index);
          } else {
            // getaway
            this.addRealisations();
          }
        }.bind(this)
      ).catch(function(msg) {
        console.log(msg);
        // TEMP: continue without thumbnail
        this.realisations[index]['thumbnail'] = "";
        if (index > 0){
          index--;
          this.multipleCallbackMedia2(index);
        } else {
          // getaway
          this.addRealisations();
        }
      }.bind(this));
    } else {
      console.log(msg);
      // TEMP: continue without thumbnail
      this.realisations[index]['thumbnail'] = "";
      if (index > 0){
        index--;
        this.multipleCallbackMedia2(index);
      } else {
        // getaway
        this.addRealisations();
      }
    }
  }
  addRealisations(){
    var realisationsListTemplate = ``;
    for(var i=0; i < this.realisations.length; i++){
      realisationsListTemplate += `<li><a
        href="${this.realisations[i]['href']}"
        title="${this.realisations[i]['title']}"
        data-id="${this.realisations[i]['id']}"
        style="background-image:url('${this.realisations[i]['thumbnail']}')"
        >
        <span>${this.realisations[i]['title']}</span>
        <img src="${this.realisations[i]['thumbnail']}">
        </a></li>`;
    }
    if(document.getElementById("realisations-realisations-list")) {
      var list = document.getElementById("realisations-realisations-list");
      this.motion.showPagination(list, realisationsListTemplate);
      this.setEventsListeners();
      //this.motion.initRealisationsListStyle();
      this.motion.enableScroll();
    }
  }
  disablePagination(){
    window.removeEventListener(
      "scroll",
      this.realisationsScrollListener,
      false
    );
  }


  /**
   * realisationsScroll
   */
  realisationsScroll() {
    this.throttledExec(this.realisationsThrottledScroll.bind(this));
  }


  /**
   * realisationsThrottledScroll
   */
  realisationsThrottledScroll(){
    if(document.getElementById("realisations-realisations-list")){
      var el = document.getElementById("realisations-realisations-list");
      var trigger = el.offsetTop + el.offsetHeight;
      var scrollPosition = window.innerHeight + window.pageYOffset;
      if(scrollPosition > trigger){
        console.log('LAUNCH');
        this.unsetEventsListeners();
        this.motion.disableScroll();
        this.loadNextRealisations();
      }
    }
  }


  /**
   * Go
   */
  go(){
    this.loadFilters();
  }


  /**
   * loadFilters
   */
  loadFilters(){
    this.ajax("/wp-json/wp/v2/domaines").then(
      function(result) {
        var data = JSON.parse(result);
        this.filters = [];
        for (var item of data) {
          var filter = [];
          filter['data-slug'] = item.slug;
          filter['href'] = item.link;
          filter['title'] = item.name;
          this.filters.push(filter);
        }
        this.loadRealisations();
      }.bind(this)
    ).catch(function(msg) {
      console.log(msg);
    });
  }


  /**
   * Load realisations
   */
  loadRealisations() {
    this.ajax("/wp-json/wp/v2/realisations?per_page=" + this.perPageFirst).then(
      function(result) {
        var data= JSON.parse(result);
        document
          .getElementById(this.currentPageId)
          .setAttribute("id", "realisations-page-container");
        this.currentPageId = "realisations-page-container";
        var index = 1;
        this.realisations = [];
        for (var item of data){
          var realisation = [];
          realisation['title'] = item.title.rendered;
          realisation['href']= item.link;
          realisation['id'] = item.id;
          // check if featured media is available
          realisation['thumbnail']
            = (item["_links"]["wp:featuredmedia"])
            ? item["_links"]["wp:featuredmedia"][0]['href']
            : "";
          this.realisations.push(realisation);
        }
        this.multipleCallbackMedia(this.realisations.length-1);
      }.bind(this)
    ).catch(function(msg) {
      console.log(msg);
    });
  }

  multipleCallbackMedia(index){
    if(this.realisations[index]["thumbnail"].length > 0) {
      this.ajax(this.realisations[index]["thumbnail"]).then(
        function(result) {
          var thumbnailObject = JSON.parse(result);
          this.realisations[index]['thumbnail']
            = thumbnailObject.media_details.sizes.realisations_list.source_url;
          console.log(thumbnailObject.media_details.sizes.full.source_url);
          console.log(this.realisations[index]['thumbnail']);
          if (index > 0){
            index--;
            this.multipleCallbackMedia(index);
          } else {
            // getaway
            this.selectDisplay();
          }
        }.bind(this)
        ).catch(function(msg) {
        console.log(msg);
        if (index > 0){
          index--;
          this.multipleCallbackMedia(index);
        } else {
          // getaway
          this.selectDisplay();
        }
      }.bind(this));
    } else {
      if (index > 0){
        index--;
        this.multipleCallbackMedia(index);
      } else {
        // getaway
        this.selectDisplay();
      }
    }
  }


  selectDisplay(){
    if (this.dryLoad){
      this.dryDisplay();
    } else {
      this.display();
    }
  }


  dryDisplay(){

    var realisationsListTemplate = ``;
    for(var i=0; i < this.realisations.length; i++){
      realisationsListTemplate += `<li><a
        href="${this.realisations[i]['href']}"
        title="${this.realisations[i]['title']}"
        data-id="${this.realisations[i]['id']}"
        style="background-image:url('${this.realisations[i]['thumbnail']}')"
        >
        <span>${this.realisations[i]['title']}</span>
        <img src="${this.realisations[i]['thumbnail']}">
        </a></li>`;
    }

    var template = `
      <ul>`;

    template += realisationsListTemplate;

    template += `
      </ul>
      <div id="realisations-spinner">
      <div class="spinner">
      <div class="cube1"></div>
      <div class="cube2"></div>
      </div>
      </div>
      `;

    // Send built event
    var e = document.createEvent("CustomEvent");
    e.initCustomEvent('page_built', false, false, {
      'slug': this.slug,
      'template': template,
      'dry': true
    });
    window.dispatchEvent(e);
  }


  display(){

    var filtersListTemplate = ``;
    var othersFilterTemplate = ``;
    for(var i=0; i < this.filters.length; i++){
      if(this.filters[i]["data-slug"]=='autres'){
        othersFilterTemplate = `
          <a
          data-slug="${this.filters[i]['data-slug']}"
          href="${this.filters[i]['href']}"
          title="${this.filters[i]['title']}">${this.filters[i]['title']}</a>
          `;
      } else {
        filtersListTemplate += `
          <a
          data-slug="${this.filters[i]['data-slug']}"
          href="${this.filters[i]['href']}"
          title="${this.filters[i]['title']}">${this.filters[i]['title']}</a>
          `;
      }
    }

    var realisationsListTemplate = ``;
    for(var i=0; i < this.realisations.length; i++){
      realisationsListTemplate += `<li><a
        href="${this.realisations[i]['href']}"
        title="${this.realisations[i]['title']}"
        data-id="${this.realisations[i]['id']}"
        style="background-image:url('${this.realisations[i]['thumbnail']}')"
        >
        <span>${this.realisations[i]['title']}</span>
        <img src="${this.realisations[i]['thumbnail']}">
        </a></li>`;
    }

    var template = `
      <div id="realisations-page" class="page">
      <section id="realisations-menu">
      <img
      src="/wp-content/themes/pepscreation/img/realisations.gif"
      alt="realisations">
      <nav>`;

    template += filtersListTemplate;
    template += othersFilterTemplate;

    template += `
      </nav>
      </section>
      <section id="realisations-realisations-list" class="realisations-list">
      <ul>`;

    template += realisationsListTemplate;

    template += `
      </ul>
      <div id="realisations-spinner">
      <div class="spinner">
      <div class="cube1"></div>
      <div class="cube2"></div>
      </div>
      </div>
      </section>
      </div>
      `;

    // Send built event
    var e = document.createEvent("CustomEvent");
    e.initCustomEvent('page_built', false, false, {
      'slug': this.slug,
      'template': template,
      'dry': false
    });
    window.dispatchEvent(e);
  }

}

export default Realisations;
